import React from 'react';
import MapUI from '../map/src/MapUI';
import { MapSection } from './right-pane.styles';
import { SpinnerLoader } from '../../Common/common-elements.styles';

const Map = ({
  destinations,
  cityRef,
  source,
  handleSelectedDestination,
  selectedDestination,
  handleOpenDtlSection,
  setNumberOfDestinations,
  numberOfDestinations
}) => {
  return (
    <MapSection isDestinationSelected={selectedDestination && selectedDestination.toCity}>
      {typeof destinations === 'undefined' ? (
        <SpinnerLoader mapLoader />
      ) : (
        <MapUI
          origins={source}
          destinations={destinations}
          cityRef={cityRef}
          handleSelectedDestination={handleSelectedDestination}
          selectedDestination={selectedDestination}
          handleOpenDtlSection={handleOpenDtlSection}
          setNumberOfDestinations={setNumberOfDestinations}
          numberOfDestinations={numberOfDestinations}
        />
      )}
    </MapSection>
  );
};

export default Map;
